
import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import { FormProvider, Controller, FieldErrors } from 'react-hook-form';
import { Input, TextArea } from '@dsi/react-eds';
import styles from './AddEditEiapCluster.module.css';
import {FormValues, useEndpointForm} from './UseEndpointForm';
import { useEffect, useState } from 'react';
import { EndpointFormData } from './EiapClusterInterfaces';

interface PropsObject {
    onSave: (values: EndpointFormData) => void;
    onError: () => void;
    endpoint: EndpointFormData | undefined;
    endpointType: string;
    saveNow: number;
}

const AddEditEnpoint = (props: PropsObject) => {

    const [showPassword, setShowPassword] = useState(false);
    const [showClientSecret, setShowClientSecret] = useState(false);

    useEffect(() => {
        if (props.saveNow === 1) {
            try {
                form.handleSubmit(() => {
                    const values = getEndpointData();
                    props.onSave(values);
                }, (errors: FieldErrors<FormValues>) => {
                    console.error('FORM ERRORS: ', errors);
                    props.onError();
                })();
            } catch {
                props.onError();
            }
        }
    }, [props.saveNow])

    const getEndpointData = (): EndpointFormData => {
        const values = form.getValues();
        return {
            url: values.url || '',
            user: values.user || '',
            password: values.password || '',
            clientId: values.clientId || '',
            clientSecret: values.clientSecret || '',
            tlsCertificate: values.tlsCertificate || ''
        }
    }

    function setIntialValues(endpointData: EndpointFormData | null | undefined): FormValues | undefined {
        if (endpointData) {
            return {
                url: endpointData.url,
                user: endpointData.user,
                password: endpointData.password,
                clientId: endpointData.clientId,
                clientSecret: endpointData.clientSecret,
                tlsCertificate: endpointData.tlsCertificate
            }
        }
        return undefined
    }
    const form = useEndpointForm(props.endpointType, setIntialValues(props.endpoint));

    return (
        <FormProvider {...form}>
            <div className="row">
                <div className='xl-12'>
                    <div className={`xl-6 lg-6 md-12 sm-12 ${styles.inputSpacing}`}>
                        <div className={styles.formElement}>
                            <label htmlFor="url" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                            {`${props.endpointType.toUpperCase()} URL`}<span style={{ color: '#dc3545' }}>*</span>
                            </label>
                            <Controller
                            name="url"
                            control={form.control}
                            render={({ field }) => (
                                <ReactEDSWrapper
                                component={Input}
                                id="url"
                                type="url"
                                placeholder={`https://${props.endpointType.toLowerCase()}.example.com`}
                                {...field}
                                />
                            )}
                            />
                            {form.formState.errors.url && (
                                <span className={styles.error}>
                                    <span className={styles.dangerIcon} aria-label="error">&#9888;</span>
                                    {form.formState.errors.url.message as string}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                <div className='xl-12'>
                    <div className='row'>
                        <div className={`xl-6 lg-6 md-12 sm-12 ${styles.inputSpacing}`}>
                        {props.endpointType !== 'EOLM' && 
                            <div className={styles.formElement}>
                                <label htmlFor="clientId" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                Client ID <span style={{ color: '#dc3545' }}>*</span>
                                </label>
                                <Controller
                                name="clientId"
                                control={form.control}
                                render={({ field }) => (
                                    <ReactEDSWrapper component={Input} id="clientId" type="text" placeholder="Client ID" {...field} />
                                )}
                                />
                                {form.formState.errors.clientId && (
                                    <span className={styles.error}>
                                        <span className={styles.dangerIcon} aria-label="error">&#9888;</span>
                                        {form.formState.errors.clientId.message as string}
                                    </span>
                                )}
                            </div>
                        }
                        {(props.endpointType === 'EOLM' || props.endpointType === 'EIC') && 
                            <div className={styles.formElement}>
                                <label htmlFor="user" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                Username {props.endpointType !== 'EIC' && <span style={{ color: '#dc3545' }}>*</span>}
                                </label>
                                <Controller
                                name="user"
                                control={form.control}
                                render={({ field }) => (
                                    <ReactEDSWrapper component={Input} id="user" type="text" placeholder="Username" {...field} />
                                )}
                                />
                                {form.formState.errors.user && (
                                    <span className={styles.error}>
                                        <span className={styles.dangerIcon} aria-label="error">&#9888;</span>
                                        {form.formState.errors.user.message as string}
                                    </span>
                                )}
                            </div>
                        }
                        
                        </div>
                        <div className={`xl-6 lg-6 md-12 sm-12 ${styles.inputSpacing}`}>
                            {props.endpointType !== 'EOLM' && 
                                <div className={styles.formElement}>
                                    <label htmlFor="clientSecret" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                    Client Secret <span style={{ color: '#dc3545' }}>*</span>
                                    </label>
                                    <Controller
                                    name="clientSecret"
                                    control={form.control}
                                    render={({ field }) => (
                                        <ReactEDSWrapper
                                        component={Input}
                                        id="clientSecret"
                                        type={showClientSecret ? 'text' : 'password'}
                                        placeholder="Client Secret"
                                        icon={`icon ${showClientSecret ? 'icon-invisible' : 'icon-eye'}`}
                                        onIconClick={() => setShowClientSecret(!showClientSecret)}
                                        {...field}
                                        />
                                    )}
                                    />
                                    {form.formState.errors.clientSecret && (
                                        <span className={styles.error}>
                                            <span className={styles.dangerIcon} aria-label="error">&#9888;</span>
                                            {form.formState.errors.clientSecret.message as string}
                                        </span>
                                    )}
                                </div>
                            }
                            {(props.endpointType === 'EOLM' || props.endpointType === 'EIC') && 
                                <div className={styles.formElement}>
                                    <label htmlFor="password" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                    Password {props.endpointType !== 'EIC' && <span style={{ color: '#dc3545' }}>*</span>}
                                    </label>
                                    <Controller
                                    name="password"
                                    control={form.control}
                                    render={({ field }) => (
                                        <ReactEDSWrapper
                                        component={Input}
                                        id="password"
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Password"
                                        icon={`icon ${showPassword ? 'icon-invisible' : 'icon-eye'}`}
                                        onIconClick={() => setShowPassword(!showPassword)}
                                        {...field}
                                        />
                                    )}
                                    />
                                    {form.formState.errors.password && (
                                        <span className={styles.error}>
                                            <span className={styles.dangerIcon} aria-label="error">&#9888;</span>
                                            {form.formState.errors.password.message as string}
                                        </span>
                                    )}
                                </div>
                            }
                        </div>
                    </div>
                </div>
                
                <div className='xl-12'>
                    <div className={`xl-12 lg-12 md-12 sm-12 ${styles.inputSpacing}`}>
                         <div className={styles.formElement}>
                            <label htmlFor="tls-cert" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                            TLS Certificate <span style={{ color: '#dc3545' }}>*</span>
                            </label>
                            <Controller
                            name="tlsCertificate"
                            control={form.control}
                            render={({ field }) => (
                                <ReactEDSWrapper
                                component={TextArea}
                                id="tls-cert"
                                rows={4}
                                placeholder="-----BEGIN CERTIFICATE-----&#10;...&#10;-----END CERTIFICATE-----"
                                {...field}
                                />
                            )}
                            />
                            {form.formState.errors.tlsCertificate && (
                                <span className={styles.error}>
                                    <span className={styles.dangerIcon} aria-label="error">&#9888;</span>
                                    {form.formState.errors.tlsCertificate.message as string}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </FormProvider>
    );
}
export default AddEditEnpoint;